import * as types from './types'
import storage from '@/plugins/storage'
var zeus = {
  get init() {
    let lookups = []
    if (storage.local.getItem(types.SESSION_CANCELREASONS)) {
      lookups['workorder.cancelreason'] = JSON.parse(storage.local.getItem(types.SESSION_CANCELREASONS))
    }
    if (storage.local.getItem(types.SESSION_WORKORDERSTATUS)) {
      lookups['workorder.status'] = JSON.parse(storage.local.getItem(types.SESSION_WORKORDERSTATUS))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATEREASONS)) {
      lookups['workorder.calibratereason'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATEREASONS))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATESYSTEMS)) {
      lookups['workorder.calibratesystem'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATESYSTEMS))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATEFIXTURES)) {
      lookups['workorder.calibratefixture'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATEFIXTURES))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATEIMAGES)) {
      lookups['workorder.calibrateimage'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATEIMAGES))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATENOTES)) {
      lookups['workorder.calibratenote'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATENOTES))
    }
    if (storage.local.getItem(types.SESSION_DYNAMIC_CONFIGURATION)) {
      lookups['configuration'] = JSON.parse(storage.local.getItem(types.SESSION_DYNAMIC_CONFIGURATION))
    }
    return lookups
  }
}
export default {
  lookups: {},
  lookupsZeus: zeus.init || [],
  groups: [],
  timeZones: JSON.parse(storage.local.getItem(types.SESSION_TIMEZONES)) || [],
  insuranceCompanies: JSON.parse(storage.local.getItem(types.SESSION_INSURANCECOMPANIES)) || [],
  vehicleMakes: JSON.parse(storage.local.getItem(types.SESSION_VEHICLEMAKES)) || [],
  odometerunits: JSON.parse(storage.local.getItem(types.SESSION_ODOMETERUNITS)) || [],
  damagepositions: JSON.parse(storage.local.getItem(types.SESSION_DAMAGEPOSITIONS)) || []
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/state.js